type BackendFormSectionTitlePropsT = {
  title: string;
};

export default function BackendFormSectionTitle({
  title,
}: BackendFormSectionTitlePropsT) {
  return (
    <h2 className="backend-form-section-title text-xl font-semibold text-gray-900">
      {title}
    </h2>
  );
}
